import axios from '../axios-on-rails';

export default class MailTemplate {
  chooseTemplate(company_profile_id, message_template_id) {
    axios.get(Routes.company_profile_mail_template_path(gon.locale, company_profile_id, message_template_id))
      .then(response => {
        const parentWindow = window.opener;
        if ( parentWindow ) {
          // fill data
          let form = parentWindow.document.forms.createdmessage;
          form.message_subject.value = response.data.subject;
          form.message_body.value = response.data.body;

          // change template_selection
          let template_selection_form = parentWindow.document.forms.template;
          let availableIds = MailTemplate._getValuesOfSelect(template_selection_form.template_id);
          if (availableIds.includes(response.data.id.toString())) {
            template_selection_form.template_id.value = response.data.id
          } else {
            template_selection_form.template_id.selectedIndex = 0
          }

        }
        window.close();
      })
  }

  static _getValuesOfSelect(selector) {
    let arr = [];
    for (let i = 0; i < selector.length; i++) {
      arr.push(selector[i].value)
    }
    return arr
  }
}
